// extracted by css-extract-rspack-plugin
export default {"root":"wfexTG","subheading":"CeC24d","error":"zZe2Fh","questions":"AOPR9B","question":"oSi5yU"};